import { formatPhoneNumber } from '@utils/strings';

import { JourneyActionValuesTypes, TravellerJourneyActionDetailed } from 'api/types';

import { PreviewSmsProps } from './preview-sms-modal';

import {
  collectBrokenVariableLabels,
  recipientTokens,
  splitAddresses,
} from '../shared/preview-variables';

// Spread into each send-sms card-menu's local locale so they share one definition.
export const previewSmsLocale = {
  en: { previewSms: 'Preview SMS' },
};

// `textMessage` is only the loading fallback; the modal fetches the real body
// from the backend preview.
export const buildSmsPreviewProps = (
  values: JourneyActionValuesTypes['send_sms'] | undefined,
  shortId: string,
  noRecipientText: string,
  action: PreviewSmsProps['action'] = 'journey',
): PreviewSmsProps => ({
  action,
  shortId,
  to: values?.recipients ? recipientTokens(values.recipients) : noRecipientText,
  textMessage: values?.message?.value ?? '',
  brokenLabels: collectBrokenVariableLabels([values?.recipients], undefined),
});

// "To" prefers the per-traveller resolved recipients, falling back to the
// template chips; `textMessage` is again only the modal's loading fallback.
export const buildSmsPreviewPropsFromTravellerAction = (
  action: TravellerJourneyActionDetailed<'send_sms'>,
): PreviewSmsProps => {
  const resolvedRecipients = splitAddresses(action.data?.recipients).map(formatPhoneNumber);
  const brokenLabels = collectBrokenVariableLabels([action.values?.recipients], undefined);

  return {
    action: 'traveller',
    shortId: action.shortId,
    // Resolved recipient if any; else template chips only when a recipient is
    // broken (keeps it red). A valid recipient resolving to empty -> [] -> "Not
    // set", not a misleading blue chip.
    to: resolvedRecipients.length
      ? resolvedRecipients
      : brokenLabels.length
        ? recipientTokens(action.values?.recipients)
        : [],
    textMessage: action.data?.message || action.values?.message?.value || '',
    date: action.result?.dateSucceeded ?? undefined,
    brokenLabels,
  };
};
